import * as React from 'react';
import { BrandLogo, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@payment-plan/ui';

/** Marco de las pantallas públicas de acceso (login, recuperar, definir contraseña). */
export function AuthCard({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 py-8">
      <Card className="w-full max-w-md">
        <CardHeader>
          <BrandLogo variant="completo" size="lg" className="mb-4 self-start" />
          <CardTitle>{title}</CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </main>
  );
}

export const ENLACE_CLASS =
  'rounded-sm text-sm font-medium text-foreground underline underline-offset-4 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';
